"use client"
/* */
import tokens from '../../../../design-tokens/dist/variables.json.mjs';

const getCategoricalColorValue = (color) => {
  return tokens.color.categorical[color].value;
};

export { getCategoricalColorValue };
//# sourceMappingURL=getCategoricalColorValue.mjs.map
